import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, CircularProgress, Typography } from '@mui/material';
import './App.css';
import { bazookaTheme } from './theme/bazookaTheme';
import { ErrorBoundary } from './components/ErrorBoundary';

// Landing page and password-protected demo
const LandingPage = lazy(() => import('./pages/LandingPage'));
const ProtectedDemo = lazy(() => import('./pages/ProtectedDemo'));
const VideoCallBazooka = lazy(() => import('./pages/VideoCallBazooka'));
const EnhancedInvestorDemo = lazy(() => import('./pages/EnhancedInvestorDemo'));
const DesignSystemShowcase = lazy(() => import('./components/DesignSystemShowcase'));
const AITeamDashboard = lazy(() => import('./components/AITeamDashboard'));
const AIOffice = lazy(() => import('./components/AIOffice/AIOffice'));
const TestHarness = lazy(() => import('./pages/TestHarness'));
const EVIDuoTest = lazy(() => import('./pages/EVIDuoTest'));
const ConnectionQuestPage = lazy(() => import('./pages/ConnectionQuestPage'));
const QuestVideoCallPage = lazy(() => import('./pages/QuestVideoCallPage'));

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={bazookaTheme}>
        <CssBaseline />
        <Router>
          <Box 
            sx={{ 
              minHeight: '100vh',
              backgroundColor: 'background.default',
            }}
          >
            <Suspense 
              fallback={
                <div className="flex flex-col items-center justify-center" style={{ minHeight: '100vh', gap: 'var(--space-3)' }}>
                  <div className="et-loader" />
                  <p className="text-base" style={{ opacity: 0.7 }}>
                    Taking a breath...
                  </p>
                </div>
              }
            >
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/demo" element={<ProtectedDemo />} />
                <Route path="/video-call" element={<VideoCallBazooka />} />
                <Route path="/investor-demo-v2" element={<EnhancedInvestorDemo />} />
                <Route path="/design-system" element={<DesignSystemShowcase />} />
                <Route path="/ai-team" element={<AIOffice />} />
                <Route path="/ai-team-old" element={<AITeamDashboard />} />
                <Route path="/test-harness" element={<TestHarness />} />
                <Route path="/evi-duo-test" element={<EVIDuoTest />} />
                <Route path="/quest" element={<ConnectionQuestPage />} />
                <Route path="/quest/call" element={<QuestVideoCallPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </Box>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
